(function($) {
   $(".search-btn").click(function() {
      $(".search-form").toggle();
   });

   $("#copyLink").click(function(e) {
       alert("The URL has been copied to your clipboard. Use CTRL + V (or CMD + V on Mac) to paste.")

       e.preventDefault();

       var dummy = document.createElement('input'),
           text = window.location.href;

       document.body.appendChild(dummy);
       dummy.value = text;
       dummy.select();
       document.execCommand('copy');
       document.body.removeChild(dummy);
   });
})(jQuery);